export { default } from './useEventCallback';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useEventCallback/index.js
// module id = 748
// module chunks = 22